import React, { useEffect, createElement } from 'react';
import { HeroSection } from '../components/sections/HeroSection';
import { PainSection } from '../components/sections/PainSection';
import { PresentationSection } from '../components/sections/PresentationSection';
import { TriedSection } from '../components/sections/TriedSection';
import { RevealSection } from '../components/sections/RevealSection';
import { MechanismSection } from '../components/sections/MechanismSection';
import { IncludesSection } from '../components/sections/IncludesSection';
import { ForWhomSection } from '../components/sections/ForWhomSection';
import { TransformationSection } from '../components/sections/TransformationSection';
import { TestimonialsSection } from '../components/sections/TestimonialsSection';
import { FinalCTASection } from '../components/sections/FinalCTASection';
import { Footer } from '../components/sections/Footer';
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    _fbq: any;
  }
}
export function SalesPage() {
  useEffect(() => {
    // Initialize Meta Pixel
    if (!window.fbq) {
      const n: any = window.fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      };
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    window.fbq('init', '1438260764322769');
    window.fbq('track', 'PageView');
  }, []);
  return <main className="min-h-screen bg-[var(--bg-deepest)] text-[var(--text-primary)] selection:bg-[var(--accent-teal)] selection:text-white" data-id="element-258">
      <HeroSection data-id="element-259" />
      <PainSection data-id="element-260" />
      <PresentationSection data-id="element-261" />
      <TriedSection data-id="element-262" />
      <RevealSection data-id="element-263" />
      <MechanismSection data-id="element-264" />
      <IncludesSection data-id="element-265" />
      <ForWhomSection data-id="element-266" />
      <TransformationSection data-id="element-267" />
      <TestimonialsSection data-id="element-268" />
      <FinalCTASection data-id="element-269" />
      <Footer data-id="element-270" />
    </main>;
}